/* eslint-disable */
import { throttle } from '../../tools/utils';
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css';
// <!-- Link Swiper's CSS -->
import '../../swiper/swiper-bundle.min.css'
import '../../swiper/animate.css'
import './index.scss';

import $ from 'jquery';
import 'bootstrap';
import '../../common/js/common';

// console.log(throttle);

// console.log('首页的js运行了～～')

$(function () {
    // banner
    new Swiper('.swiper-container', {
        loop: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        on: {
            init: function () {
                // swiperAnimateCache(this); //隐藏动画元素 
                // swiperAnimate(this); //初始化完成开始动画
            },
            slideChangeTransitionEnd: function () {
                // swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
                //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
            }
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        },
        loop: true
    });

    // 案例展示
    new Swiper('.swiper-container2', {
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: true,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1.2,
        coverflowEffect: {
            rotate: 0,
            stretch: -200,
            depth: 400,
            modifier: 1,
            slideShadows: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        on: {
            transitionStart: function (swiper) {
                // console.log(swiper)
                // swiper.el.addClass('sss')
                swiper.$el.addClass('MyClass');
            },
            // init: function () {
            //     swiperAnimateCache(this); //隐藏动画元素 
            //     this.emit('slideChangeTransitionEnd');//在初始化时触发一次slideChangeTransitionEnd事件
            // },
            // slideChangeTransitionEnd: function () {
            //     swiperAnimate(this); //每个slide切换结束时运行当前slide动画
            //     // this.slides.eq(this.activeIndex).find('.ani').removeClass('ani');//动画只展示一次
            // }
        },
    });
})



